<template>
  <div>
    <!-- <v-card color="grey lighten-4">
            <v-snackbar :timeout="timeout" :color="color" :left="left" v-model="snackbar">{{ message }}</v-snackbar>
        </v-card> -->
    <v-container>
      <!-- Form -->
      <v-card>
        <v-card-title>
          <span class="headline">{{ formTitle }}</span>
        </v-card-title>
        <v-form v-model="valid" ref="form" lazy-validation>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12 sm4 md4>
                  <v-autocomplete
                    label="Economic Code"
                    item-text="eco_name_no"
                    item-value="eco_account_code"
                    :items="eco_code"
                    v-model="formSchema.eco_code"
                    :rules="[(v) => !!v || 'Field is required']"
                    required
                  ></v-autocomplete>
                </v-flex>

                <v-flex xs12 sm4 md4>
                  <v-text-field
                    label="Admin Head Name"
                    v-model="formSchema.head_name"
                    :rules="[(v) => !!v || 'Field is required']"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md4>	
								     <v-checkbox v-model="formSchema.active" label="Active" :value="isActiveVal"></v-checkbox>
									</v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="success" @click.native="validateBeforeSubmit">{{
              btnTitle
            }}</v-btn>
            <v-btn color="error" @click.native="reset">Reset</v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
      <!-- /Form -->
    </v-container>
  </div>
</template>
<script>
/**
 * ---------------------
 *  implements by majeed
 * ---------------------
 */
const commonService = require("../../../services/common.service");

import { preFix } from "../../../vuex/api";
import Axios from "axios";
export default {
  props: ["formSchema"],
  data: () => ({
    valid: true,
    dialog: false,
    dialogEditForm: false,
    isActiveVal: 0,
    search: "",
    totalItems: 0,
    loading: true,
    eco_code:[],
    pagination: {
      sortBy: "id",
      descending: true,
    },
    selected: [],
    search: "",
    headers: [
      {
        text: "Name",
        align: "left",
        sortable: false,
        value: "name",
      },
      { text: "User Type", align: "left", value: "type_id" },
      { text: "Email", value: "email" },
    ],

    delete_id: "",
    row_index: "",
    dialog2: false,
    snackbar: false,
    color: "success",
    mode: "",
    timeout: 3000,
    left: "left",
    message: "",

    select: null,
    instituteList: [],

    typelist: [],

    instituteShow: true,
  }),

  computed: {
    formTitle() {
      return this.formSchema.id > 0
        ? "Update Administrative Sub Head"
        : "Add Administrative Sub Head";
    },
    btnTitle() {
      return this.formSchema.id > 0 ? "Update" : "Save";
    },
  },

  created() {
    commonService.getAllData("economy-code-info").then((res) => {
      this.eco_code = res.data;
      this.eco_code.forEach((c,i,f)=>{
          c.eco_name_no = c.eco_account_name+' ('+c.eco_account_code+')'
        }) 
    });
  },

  methods: {
    changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending;
      } else {
        this.pagination.sortBy = column;
        this.pagination.descending = false;
      }
    },

    validateBeforeSubmit(e) {
      var formSchema = this.formSchema;
      var root = this;

      if (this.$refs.form.validate()) {
        if (formSchema.id > 0) {
          commonService
            .updateFormData(this.formSchema, "sub_head")
            .then((res) => {
              // if(res.status == 1){
              //   this.message ='Data updated successfully!';
              //   this.snackbar = true
              //   this.$refs.form.reset();
              //   this.formSchema.id = 0
              //   this.$emit('reloadData')
              // }
              let actionData = {
                message: res.message,
                data: res.data,
                action: "edit",
                status: res.status,
              };
              this.close(actionData);
            });
        } else {
          commonService
            .insertFormData(this.formSchema, "sub_head")
            .then((res) => {
              // if(res.status == 1){
              //   this.message ='Data created successfully!';
              //   this.snackbar = true
              //   this.$refs.form.reset();
              //   this.$emit('reloadData')
              // }
              let actionData = {
                message: res.message,
                data: res.data,
                action: "add",
                status: res.status,
              };
              this.close(actionData);
            });
        }
      }
    },

    close: function(message) {
      if (message.status == 1) {
        this.$refs.form.reset();
      }
      this.$emit("reloadData", message);
    },
     reset() {
      if (this.formSchema.id > 0) {
        close(0);
      } else {
        this.$refs.form.reset();
      }
    },
  },

  watch: {
    // props re-activity
    item() {
      this.formSchema = this.item;
      console.log(this.formSchema);
    },
  },

  mounted() {},
};
</script>



// WEBPACK FOOTER //
// src/components/administration/sub_head_entry/sub_head_form.vue